import { EDIT_CAMPAIGN_NAME } from 'api/CampaignAPI';
import { ApiMethod } from 'services/api';
import { UseRestMutationOptions, useRestMutation } from 'utils/hooks/api/useRestMutation';

type EditCampaignNameBody = { campaignId: number; name: string };
type EditCampaignNameResponse = string;

export const useEditCampaignNameMutation = (
  options?: UseRestMutationOptions<EditCampaignNameResponse>,
) => {
  const { isLoading, error, data, mutate } = useRestMutation<
    EditCampaignNameResponse,
    EditCampaignNameBody
  >(EDIT_CAMPAIGN_NAME, ApiMethod.post, {
    ...options,
  });

  return {
    isLoading,
    error,
    data,
    mutate,
  };
};
